import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { Error } from '../../shared/models/error.model';
import { RequestService } from '../../shared/services/request.service';
import { RatingStatus } from './enums/rating-status.enum';
import { RatingType } from './enums/rating-type.enum';
import { RatingFilter } from './models/rating-filter.model';
import { Rating, RatingsResponse } from './models/rating.model';

@Injectable()
export class RatingService {

	constructor(private requestService: RequestService) { }

	getRatings(filter: RatingFilter, page: number, size: number): Promise<RatingsResponse> {
		return new Promise((resolve, reject) => {
			const params: any = {
				establishmentId: filter.establishmentId,
				page: page,
				size: size,
				count: filter.count
			};
			let urlRequest: string = this.requestService.buildUrlPathParams(params, APP_CONFIG.WEBSERVICE.GET_RATINGS);

			if (filter.statusId !== "ALL") {
				const filterStatus: any = filter.getFilterStatus().find((status: any) => {
					return status.id === filter.statusId;
				});
				if (filterStatus) {
					// status=1&status=2&status=3
					filterStatus.status.forEach((status: RatingStatus) => {
						urlRequest += '&status=' + status;
					});
				}
			}
			if (filter.productId) {
				urlRequest += '&productId=' + filter.productId;
			}
			if (filter.types && filter.types.length > 0) {
				filter.types.forEach((type: RatingType) => {
					urlRequest += '&types=' + type;
				});
			}
			console.log(urlRequest);
			this.requestService.getData(urlRequest).then((response: RatingsResponse) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getRatingsByOrderId(orderId: number): Promise<Array<Rating>> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams({ orderId: orderId }, APP_CONFIG.WEBSERVICE.GET_ORDER_RATING);
			this.requestService.getData(urlRequest).then((response: RatingsResponse) => {
				const ratings: Array<Rating> = new Array();
				if (response && response.ratings) {
					response.ratings.forEach((rating: Rating) => {
						ratings.push(new Rating(rating));
					});
				}
				resolve(ratings);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	approveRating(rateId: number): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				rateId: rateId,
				status: RatingStatus.PUBLISH
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.APPROVE_RATING, data).then((response: any) => {
				console.log(response);
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	sendToModeration(rateId: number): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				rateId: rateId,
				isAnswer: false
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.SEND_TO_MODERATION, data).then((response: any) => {
				console.log(response);
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	answerComment(rateId: number, userId: number, orderId: number, comment: string): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				rateId: rateId,
				userId: userId,
				orderId: orderId,
				comment: comment
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.ANSWER_COMMENT, data).then((response: any) => {
				console.log(response);
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/rating/rating.service.ts